module.exports = __webpack_public_path__ + "img/section2_pic2.e821a618.png";